import PrzekazyGetList from "./przekazyGetList";

const data = () => {
	return PrzekazyGetList();
};

export default data;
